import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

const default_mqtt = {
  host: "wss://broker.emqx.io:8084/mqtt",
  topic: "/m-serial",
  options: {
    username: null,
    password: null,
    clientId: 'm-serial_' + Math.random().toString(16).substr(2, 8),
    clean: true,
  }
}
const default_messages = {
  list: [
  ]
}
const default_alarms = []
const default_serial = {
  enable: false,
  baudrate: 9600,
  enable_decoder: false,
  decoder: "function (message) {\n  var tmp = {};\n  var topic = \"/m-serial\";   //Your Topic\n\n  tmp.topic = topic;\n  tmp.message = message;\n\n  return tmp;\n}",
}


const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});

const store = new Vuex.Store({
    state: {
    mqtt: default_mqtt,
    messages: default_messages,
    alarms: default_alarms,
    serial: default_serial,
  },
  getters: {
    getMQTTConfig(state) {
      return Object.assign({}, state.mqtt);
    },
  },
  mutations: {
    setMQTTConfig(state, mqtt) {
      state.mqtt = mqtt
    },
    resetMQTTConfig(state) {
      state.mqtt = default_mqtt
    },
    pushMessage(state, message) {
      state.messages.list.push(message);
    },
    clearMessages(state) {
      state.messages.list = [];
    },
    pushAlarm(state, alarm) {
      state.alarms.unshift(alarm);
    },
    deleteAlarm(state, index) {
      state.alarms.splice(index, 1);
    },
    setSerialConfig(state, serial) {
      state.serial = serial
    },
    setDecoder(state, decoder) {
      state.serial.decoder = decoder;
    },
  },
  plugins: [vuexLocal.plugin],
});
export default store;

// import { createStore } from 'vuex'

// export default createStore({
// })